export default "__VITE_ASSET__CYdNRKXx__"